import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Form, InputGroup, Spinner } from 'react-bootstrap';
import { FaUser } from 'react-icons/fa';
import './index.css';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useAuth } from '../../contexts/auth-context';
import { PERFIS } from '../../constants/perfis/index';
import fechamentoService from '../../api/fechamentoService';

const Fechamento = () => {
    const { user } = useAuth();
    const [loading, setLoading] = useState(false);
    const [atendimentosPorMes, setAtendimentosPorMes] = useState([]);
    const [atendimentosFiltrados, setAtendimentosFiltrados] = useState([]);
    const [profissionalSelecionado, setProfissionalSelecionado] = useState('');
    const [mesSelecionado, setMesSelecionado] = useState(new Date().getMonth() + 1);
    const [anoSelecionado, setAnoSelecionado] = useState(new Date().getFullYear());

    useEffect(() => {
        carregarAtendimentos();
    }, [mesSelecionado, anoSelecionado]);

    useEffect(() => {
        filtrarAtendimentos();
    }, [profissionalSelecionado, atendimentosPorMes]);

    const carregarAtendimentos = async () => {
        setLoading(true);
        try {
            const mes = mesSelecionado !== 'Todos' ? mesSelecionado : null;
            const profissionalId = user.perfilId === PERFIS.ADMINISTRADOR ? null : user.profissionalId;
            const response = await fechamentoService.obter(anoSelecionado, mes, profissionalId);
            setAtendimentosPorMes(response);
            setAtendimentosFiltrados(response);
            setLoading(false); 
        } catch (error) {
            console.error('Erro ao buscar dados de fechamento', error);
            setLoading(false); 
        }
    };

    const removerAcentos = (texto) => {
        return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    };

    const filtrarAtendimentos = () => {
        if (!profissionalSelecionado) {
            setAtendimentosFiltrados(atendimentosPorMes);
            return;
        }

        const filtroNormalizado = removerAcentos(profissionalSelecionado).toLowerCase();
        const atendimentosFiltrados = atendimentosPorMes.filter(atendimento => {
            const nomeNormalizado = removerAcentos(atendimento.profissionalNome).toLowerCase();
            return nomeNormalizado.includes(filtroNormalizado);
        });

        setAtendimentosFiltrados(atendimentosFiltrados);
    };

    const handleFiltroProfissional = (e) => {
        setProfissionalSelecionado(e.target.value);
    };

    const handleMesChange = (e) => {
        setMesSelecionado(e.target.value);
    };

    const handleAnoChange = (e) => {
        setAnoSelecionado(e.target.value);
    };

    const gerarAnos = () => {
        const anoAtual = new Date().getFullYear();
        const anos = [];
        for (let ano = 2024; ano <= anoAtual; ano++) {
            anos.push(ano);
        }
        return anos;
    };

    const meses = ['Todos', 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

    return (
        <div className="agenda-container">
            <Card className="agendamento-card shadow-sm">
                <Card.Body>
                    <Card.Title className="text-center mb-4">Fechamento Mensal</Card.Title>
                    <hr />
                    <Row className="mb-3">
                        {user && user.perfilId === PERFIS.ADMINISTRADOR && (
                            <Col md={2} sm={12}>
                                <Form.Group controlId="anoSelecionado">
                                    <Form.Label>Ano</Form.Label>
                                    <Form.Control as="select" className="form-select" value={anoSelecionado} onChange={handleAnoChange}>
                                        {gerarAnos().map((ano, index) => (
                                            <option key={index} value={ano}>{ano}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                        )}
                        <Col md={2} sm={12}>
                            <Form.Group controlId="mesSelecionado">
                                <Form.Label>Mês</Form.Label>
                                <Form.Control as="select" className="form-select" value={mesSelecionado} onChange={handleMesChange}>
                                    {meses.map((mes, index) => (
                                        <option key={index} value={index === 0 ? 'Todos' : index}>{mes}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        {user && user.perfilId === PERFIS.ADMINISTRADOR && (
                            <Col md={8} sm={12}>
                                <Form.Group controlId="filtroProfissional">
                                    <Form.Label>Profissional</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FaUser />
                                        </InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            name="profissionalFiltro"
                                            value={profissionalSelecionado}
                                            onChange={handleFiltroProfissional}
                                            placeholder="Digite o nome do profissional"
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        )}
                    </Row>
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>Mês</th>
                                    {user && user.perfilId === PERFIS.ADMINISTRADOR && <th>Profissional</th>}
                                    <th>Quantidade</th>
                                    <th>Valor Total (R$)</th>
                                </tr>
                            </thead><tbody>
    {loading ? (  
        <tr>
            <td colSpan={user?.perfilId === PERFIS.ADMINISTRADOR ? 4 : 3}>
                <Spinner 
                    as="span" 
                    animation="border" 
                    size="sm" 
                    role="status" 
                    aria-hidden="true" 
                />
            </td>
        </tr>
                ) : (
                    atendimentosFiltrados.length > 0 ? 
                        atendimentosFiltrados.map((mes, index) => (
                            <tr key={index}>
                                <td>{format(new Date(mes.ano, mes.mes - 1), 'MMMM', { locale: ptBR }).toUpperCase()}</td>
                                {user && user.perfilId === PERFIS.ADMINISTRADOR && <td>{mes.profissionalNome}</td>}
                                <td>{mes.totalAtendimentos}</td>
                                <td>R$ {mes.totalAPagar.toFixed(2)}</td>
                            </tr>
                        ))
                    : 
                        <tr>
                            <td colSpan={user?.perfilId === PERFIS.ADMINISTRADOR ? 4 : 3}>Nenhum dado disponível</td>
                        </tr>
                )}
            </tbody>
                        </table>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default Fechamento;
